import { connect } from 'react-redux'
import Search from 'components/layout/search/Search'
import { setCurrentSearchPhrase, setCurrentSearchType, submitSearchUpdate } from 'redux/actions'

const mapStateToProps = state => ({
  aol: state.aol,
  aolConfigLoaded: state.aol.aolConfigLoaded,
  flavour: state.layout.flavour,
  searchType: state.search.searchType
})

const mapDispatchToProps = dispatch => ({
  submitSearchUpdate: (props) => dispatch(submitSearchUpdate(props)),
  setCurrentSearchType: searchType => dispatch(setCurrentSearchType(searchType)),
  setCurrentSearchPhrase: searchPhrase => dispatch(setCurrentSearchPhrase(searchPhrase))
})

export default connect(mapStateToProps, mapDispatchToProps)(Search)
